import { UseCase } from "../../useCase"
import { ExportTournamentResponse } from "./response"
import { ExportTournamentRequest } from "./request"
import { SellerServicesRepository } from "../../../repositories/sellerServicesRepository"

export class ExportTournamentUseCase implements UseCase<ExportTournamentRequest, ExportTournamentResponse> {
	private _repository
	constructor({ SellerServicesRepository }: { SellerServicesRepository: SellerServicesRepository }) {
		this._repository = SellerServicesRepository
	}

	exec({ serviceId }: ExportTournamentRequest) {
		return this._repository.exportTournament(serviceId)
	}
}
